/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';
import type Survey from '@linc-technologies/linced-common/models/surveys/survey';

// Proto: surveys.SurveyResponse.
export default class Response extends Model {
  declare [Type]: 'surveys/response';

  // Survey response metadata
  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @attr('string')
  declare campusId: string | undefined;

  // authorId: the author of this response.
  // Not a relationship, as caregivers may not have access to the author (i.e. other caregiver).
  @attr('string')
  declare authorId: string | undefined;

  // personId: the learner to whom this response relates.
  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  // surveyId: The unique ID of the survey this is a response to.
  @belongsTo('surveys/survey', { async: true, inverse: null })
  declare surveyId: AsyncBelongsTo<Survey>;

  @alias('surveyId')
  declare survey: AsyncBelongsTo<Survey>;

  // answer: The selected answer.
  @attr('string')
  declare answer: string | undefined;
}
